import { useAccountContext } from '~/modules/account/context'
import { useCurrentChannel } from '~/app/state/hooks'

export const TRACKING_EVENTS = {
  COMMENT_DISMISSED: 'Comment Dismissed',
  COMMENT_REPLIED: 'Comment Replied',
  COMMENT_SELECTED: 'Comment Selected',
  POSTS_LOADED: 'Posts Loaded',
  POST_SELECTED: 'Post Selected',
  CHANNEL_SELECTED: 'Channel Selected',
  ALL_POST_COMMENTS_DISMISSED: 'All Post Comments Dismissed',
  PAGE_VIEWED: 'Page Viewed',
  CHANNEL_BACKFILL_COMPLETED: 'Channel Backfill Completed',
}

/**
 *
 */
export const useTrackEvent = () => {
  const { getCurrentChannel } = useCurrentChannel()
  const account = useAccountContext()

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  return (event, payload = {}) => {
    const currentChannel = getCurrentChannel()

    // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
    if (!account?.id || account.isImpersonation) {
      return
    }

    // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
    const organization = account.currentOrganization
    if (!organization?.id) {
      return
    }

    const eventData = {
      product: 'engage',
      organizationId: organization.id,
      ...buildChannelData(currentChannel),
      ...payload,
    }

    if (window.analytics) {
      window.analytics.track(event, eventData)
    }
  }
}

/**
 *
 */
export const useTrackPageViewed = () => {
  const trackEvent = useTrackEvent()

  return (metadata = {}) => {
    trackEvent(TRACKING_EVENTS.PAGE_VIEWED, {
      channelType: 'business',
      name: null,
      platform: null,
      referrer: null,
      search: null,
      title: null,
      cta: null,
      ctaApp: null,
      ctaView: null,
      ctaLocation: null,
      ctaButton: null,
      ctaVersion: null,
      ...metadata,
    })
  }
}

/**
 *
 */
export const useTrackCommentProcessed = () => {
  const trackEvent = useTrackEvent()

  // @ts-expect-error TS(7006) FIXME: Parameter 'mutationName' implicitly has an 'any' t... Remove this comment to see the full error message
  return (mutationName, post, comment, metadata = {}) => {
    if (!post || !comment) {
      return
    }

    const event =
      mutationName === 'engageReply'
        ? TRACKING_EVENTS.COMMENT_REPLIED
        : TRACKING_EVENTS.COMMENT_DISMISSED

    trackEvent(event, {
      ...buildPostData(post),
      ...buildCommentData(comment),
      ...metadata,
    })
  }
}

/**
 *
 */
export const useTrackCommentSelected = () => {
  const trackEvent = useTrackEvent()

  // @ts-expect-error TS(7006) FIXME: Parameter 'post' implicitly has an 'any' type.
  return (post, comment, metadata = {}) => {
    if (!post || !comment) {
      return
    }

    trackEvent(TRACKING_EVENTS.COMMENT_SELECTED, {
      ...buildCommentData(comment),
      postId: post.id,
      ...metadata,
    })
  }
}

/**
 *
 */
export const useTrackPostSelected = () => {
  const trackEvent = useTrackEvent()

  // @ts-expect-error TS(7006) FIXME: Parameter 'post' implicitly has an 'any' type.
  return (post, filter = null) => {
    if (!post) {
      return
    }

    const labels = getLabels(post.labelsCount)

    trackEvent(TRACKING_EVENTS.POST_SELECTED, {
      ...buildPostData(post),
      hasLabel: labels.length > 0,
      labelTypes: labels,
      postsFiltered: !!filter,
    })
  }
}

/**
 *
 */
export const useTrackPostsLoaded = () => {
  const trackEvent = useTrackEvent()

  // @ts-expect-error TS(7006) FIXME: Parameter 'channel' implicitly has an 'any' type.
  return (channel) => {
    if (!channel) {
      return
    }

    const labels = getLabels(channel.labelsCount)

    trackEvent(TRACKING_EVENTS.POSTS_LOADED, {
      ...buildChannelData(channel),
      totalComments: channel.totalComments,
      totalUnansweredComments: channel.totalPendingComments,
      hasLabels: labels.length > 0,
      postsWithLabel: 0, // TODO.
      labelTypes: labels,
    })
  }
}

/**
 *
 */
export const useTrackChannelSelected = () => {
  const trackEvent = useTrackEvent()

  // @ts-expect-error TS(7006) FIXME: Parameter 'channel' implicitly has an 'any' type.
  return (channel) => {
    if (!channel) {
      return
    }

    trackEvent(TRACKING_EVENTS.CHANNEL_SELECTED, {
      ...buildChannelData(channel),
      channelType: 'business',
      channel: channel.service,
    })
  }
}

/**
 *
 */
export const useTrackChannelBackfillDone = () => {
  const trackEvent = useTrackEvent()

  // @ts-expect-error TS(7006) FIXME: Parameter 'channel' implicitly has an 'any' type.
  return (channel, backfill) => {
    if (!channel || !backfill) {
      return
    }

    trackEvent(TRACKING_EVENTS.CHANNEL_BACKFILL_COMPLETED, {
      ...buildChannelData(channel),
      channelType: 'business',
      channel: channel.service,
      backfillDuration: backfill.backfillDuration,
      backfillEndedAt: backfill.backfillEndedAt,
      backfillStartedAt: backfill.backfillStartedAt,
    })
  }
}

/**
 *
 */
export const useTrackAllPostCommentsDismissed = () => {
  const trackEvent = useTrackEvent()

  // @ts-expect-error TS(7006) FIXME: Parameter 'post' implicitly has an 'any' type.
  return (post) => {
    if (!post) {
      return
    }

    const labels = getLabels(post.labelsCount)

    trackEvent(TRACKING_EVENTS.ALL_POST_COMMENTS_DISMISSED, {
      ...buildPostData(post),
      hasLabel: labels.length > 0,
      labelTypes: labels,
      isGiveaway: true,
    })
  }
}

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'channel' implicitly has an 'any' type.
function buildChannelData(channel) {
  const { id = null, serviceId = null, name = null } = channel || {}

  return {
    channelId: id,
    channelServiceId: serviceId,
    channelUsername: name,
  }
}

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'comment' implicitly has an 'any' type.
function buildCommentData(comment) {
  if (!comment) {
    return {}
  }

  const { labels = [] } = comment

  return {
    commentId: comment.id,
    hasLabel: labels.length > 0,
    labelTypes: labels,
  }
}

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'post' implicitly has an 'any' type.
function buildPostData(post) {
  return post
    ? {
        postId: post.id,
        totalComments: post.totalComments,
        totalUnansweredComments: post.totalPendingComments,
      }
    : {}
}

/**
 *
 */
function getLabels(labelCounters = []) {
  return (
    labelCounters
      // @ts-expect-error TS(2339) FIXME: Property 'count' does not exist on type 'never'.
      .filter((el) => el.count > 0)
      // @ts-expect-error TS(2339) FIXME: Property 'label' does not exist on type 'never'.
      .map((counter) => counter.label)
  )
}
